import { Component } from '@verndale/core';

class ContentWithMediaRow extends Component {
  setupDefaults() {
    this.dom = {
      navAnchorTargets: this.el.querySelectorAll('a[href^="#"]'),
      navSelectMobile: this.el.querySelector(
        '.content-side-navigation__select'
      ),
      anchorTargetSections: []
    };
    this.setAnchorTargetSections();
    this.options = {
      root: null,
      threshold: 0,
      rootMargin: '0% 0% -75%'
    };
    this.observer = new IntersectionObserver(
      this.handleIntersectionObserver.bind(this),
      this.options
    );
    this.dom.anchorTargetSections.forEach(el =>
      this.observer.observe(el)
    );
  }

  addListeners() {
    this.dom.navAnchorTargets.forEach(el =>
      el.addEventListener('click', this.handleAnchorClick.bind(this))
    );
    this.dom.navSelectMobile.addEventListener(
      'change',
      this.handleSelectChange.bind(this)
    );
  }

  handleIntersectionObserver(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      this.dom.navAnchorTargets.forEach(el => el.classList.remove('active'));
      const correspondingAnchorElement = Array.from(
        this.dom.navAnchorTargets
      ).find(navanchor =>
        navanchor.getAttribute('href').includes(entry.target.id)
      );
      correspondingAnchorElement.classList.add('active');
    });
  }

  setAnchorTargetSections() {
    this.dom.navAnchorTargets.forEach(el => {
      if (document.querySelector(el.getAttribute('href')))
        this.dom.anchorTargetSections.push(
          document.querySelector(el.getAttribute('href'))
        );
    });
  }

  scrollToElement(targetElement) {
    if (targetElement) {
      const elementTop = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementTop + window.pageYOffset - 100; // replace 100 for header height once known
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  handleAnchorClick(e) {
    e.preventDefault();
    const targetElement = document.querySelector(e.target.getAttribute('href'));
    this.scrollToElement(targetElement);
  }

  handleSelectChange(e) {
    if (e.target.value[0] === '#') {
      const targetElement = document.querySelector(e.target.value);
      this.scrollToElement(targetElement);
    } else {
      window.location.href = e.target.value;
    }
  }
}

export default ContentWithMediaRow;
